// Pendant Materials
enum PendantMaterials {
  SILVER = "silver",
  ONYX = "onyx",
  GOLD = "gold",
}

export default PendantMaterials;
